<template>
  <div class="t-divider"></div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.t-divider {
  width: 100%;
  height: 1px;
  background-color: var(--t-color-border-secondary);
}
</style>
